import type { RangeFilter } from '@schibsted-nmp/search-frontend-clients/quest';
import React from 'react';

export function useRangeValues(filter: RangeFilter) {
    const lowerFilterValue = filter.value_from?.toString() ?? '';
    const upperFilterValue = filter.value_to?.toString() ?? '';

    const [lowerValue, setLowerValue] = React.useState(lowerFilterValue);
    const [upperValue, setUpperValue] = React.useState(upperFilterValue);

    React.useEffect(() => {
        // Keep the range value in sync with the API response
        setLowerValue(lowerFilterValue);
        setUpperValue(upperFilterValue);
    }, [lowerFilterValue, upperFilterValue]);

    const setRangeValues = React.useCallback(
        ({ lower, upper }: { lower?: string; upper?: string }) => {
            typeof lower !== 'undefined' && setLowerValue(lower);
            typeof upper !== 'undefined' && setUpperValue(upper);
        },
        [],
    );

    return { lowerValue, upperValue, setRangeValues };
}
